class CustomAnnouncementBar extends HTMLElement {
  connectedCallback() {
    this._items = Array.from(this.querySelectorAll('.announcement-bar__item'));
    if (this._items.length <= 1) return;

    this._current = 0;
    this._timer = null;

    const autoplay = this.dataset.autoplay === 'true';
    const interval = parseInt(this.dataset.interval, 10) || 4000;

    if (autoplay) this._start(interval);

    document.addEventListener('shopify:block:select', (e) => {
      if (!this.contains(e.target)) return;
      this._stop();
      const idx = this._items.findIndex(el => el === e.target || el.contains(e.target));
      if (idx !== -1) this._show(idx);
    });

    document.addEventListener('shopify:block:deselect', (e) => {
      if (!this.contains(e.target)) return;
      if (autoplay) this._start(interval);
    });
  }

  disconnectedCallback() {
    this._stop();
  }

  _show(index) {
    this._items.forEach((el, i) => { el.hidden = i !== index; });
    this._current = index;
  }

  _start(interval) {
    this._stop();
    this._timer = setInterval(() => {
      this._show((this._current + 1) % this._items.length);
    }, interval);
  }

  _stop() {
    clearInterval(this._timer);
    this._timer = null;
  }
}

if (!customElements.get('custom-announcement-bar')) {
  customElements.define('custom-announcement-bar', CustomAnnouncementBar);
}
